// extracted by mini-css-extract-plugin
export default {"wrapper":"qr_wrapper__9yUbA"};